
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/app/services';
//import { Alerts, AlertResponse } from 'src/app/models';
import { LazyLoadEvent } from 'primeng/api/public_api';

@Component({
  selector: 'bart-alert-main',
  templateUrl: './alert-main.component.html',
  styleUrls: ['./alert-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertMainComponent implements OnInit {
  getAlertsParam = {
    userID : 36679,
    bartRoleID: 20,
    alertStatusID: 4,
    location_id_list: '1,2'
  };
  //Table Binding source
  public dataSource: any[];
  public data: any[];
  public cols: any[];
  public totalRecords:number=0;
  loading = false;
  constructor
  (
    private changeDetectorRef: ChangeDetectorRef, 
    private activatedRoute: ActivatedRoute,
    private alertService: AlertsService
    ) {}
  ngOnInit() {
    //this.getAlertsByUserId();
    this.totalRecords=0;
    this.cols = [
      { field: 'AlertDetail', header: 'AlertDetail' },
    ];
  }
  public getAlertsByUserId() {
    // if (this.getAlertsParam != null) {
    //   this.loading = true;
    //   this.alertService.getAlertsByUserId(this.getAlertsParam)
    //   .subscribe((allAlertResponse: Array<any>) => {
    //       this.data = allAlertResponse['response'];
    //       this.totalRecords = this.data.length;
    //     }, (respose: Response) => {
    //       this.data = [];
    //       // handle error here
    //     }
    //   );
    // }
  }
  public loadDataOnScroll(event: LazyLoadEvent) {
    this.loading = true;
    setTimeout(() => {
    if (this.data) {
      this.totalRecords=this.data.length;
      this.dataSource = this.data.slice(event.first, (event.first + event.rows));
    }
    this.loading = false;
    this.changeDetectorRef.detectChanges();
  }, 1000);
  
  }
  public removeAlert()
  {
    alert("Are you want remove this item from list ?");
  }
}
